import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/dashboard/dashboard.css';
// import CourseCard from './course-card/CourseCard';
import CourseCard from './course-card2.0/CourseCard';

export default function Dashboard() {
    const username = window.memberstack.information.username;
    const navigate = useNavigate();
    const [plan, setPlan] = useState("");

    useEffect(() => {
        window.MemberStack.onReady.then(member => {
            setPlan(member.membership.name)
        });
    });

    return (
        <div className="dashboard-container">
            <div className="header-greeting">
                <h1>Welcome, {username}!</h1>
                <h4>Membership: {plan}</h4> 
                <span className="upgrade-link"> 
                    Upgrade
                    <svg xmlns="http://www.w3.org/2000/svg" className="upgrade-svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 11l3-3m0 0l3 3m-3-3v8m0-13a9 9 0 110 18 9 9 0 010-18z" />
                    </svg>
                </span>
            </div>

            <h2>Choose a course:</h2>

            <div className="new-course-card-container">
                <CourseCard 
                    color={'rgba(0, 0, 0, 0.8)'}
                    faIcon={'fas fa-laptop-code'}
                    title={'Getting Started'}
                    path={"/getting-started/overview"}
                    motto={'"Begin your journey here."'}
                    iconSize={'56px'}
                />
                <CourseCard 
                    color={'rgba(233,98,40, 0.8)'}
                    faIcon={'fab fa-html5'}
                    title={'HTML'}
                    path={"/html/overview"}
                    motto={'"The markup language for describing the layout of all websites."'}
                    iconSize={'72px'}
                />
                <CourseCard 
                    color={'rgba(39,77,228, 0.8)'}
                    faIcon={'fab fa-css3-alt'}
                    title={'CSS'}
                    path={"/html/overview"}
                    motto={'"The styling and presentation rules of websites."'}
                    iconSize={'72px'}
                />
                <CourseCard 
                    color={'rgba(239,216,29, 1)'}
                    faIcon={'fab fa-js'}
                    title={'JavaScript'}
                    path={"/javascript/overview"}
                    motto={'"The scripting language and powerhouse of the World Wide Web."'}
                    iconSize={'72px'}
                />
            </div>
            <div className="new-course-card-container">
                <CourseCard 
                    color={'rgb(94,211,243)'}
                    faIcon={'fab fa-react'}
                    title={'React'}
                    path={"/getting-started/overview"}
                    motto={'A powerful JavaScript library.'}
                    iconSize={'62px'}
                />
            </div>
        </div>
    )
}
